import React, { useState, useEffect } from "react";
import axiosInstance from '../../../axiosInstance';
import { useNavigate } from "react-router-dom";
import DataTableComponent from "../../common/DataTable/PrimeDataTable";

const ManufacturerSiteList = ({ persona }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [paginationParams, setPaginationParams] = useState({
    limit: 10,
    offset: 0,
    sortField: "createdAt",
    sortOrder: -1
  });
  const navigate = useNavigate();

  useEffect(() => {
    fetchManufacturersSites();
  }, [paginationParams]);

  const fetchManufacturersSites = async () => {
    setLoading(true);
    try {
      // determine endpoint based on persona
      const endpoint = persona === 'customer' 
        ? `/api/manufacturers-sites/enduser`
        : `/api/manufacturers-sites`;
      
      const response = await axiosInstance.get(endpoint, { withCredentials: true });
      setData(response?.data || []);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const onDataTableEvent = (event) => {
    setPaginationParams((prev) => ({
      ...prev,
      limit: event.rows,
      offset: event.first,
      sortField: event.sortField || prev.sortField,
      sortOrder: event.sortOrder || prev.sortOrder
    }));
  };

  const columns = [
    { field: "id", header: "ID", sortable: true },
    { 
      field: "manufacturer_license", 
      header: "Manufacturer License", 
      sortable: true, 
      filter: true 
    },
    { 
      field: "manufacturer_name", 
      header: "Manufacturer Name", 
      sortable: true, 
      filter: true 
    },
    { 
      field: "manufacturers_site_address", 
      header: "Manufacturing Site Address", 
      sortable: true, 
      filter: true 
    },
    { 
      field: "activity", 
      header: "Activity", 
      sortable: true, 
      filter: true 
    },
    { 
      field: "phone", 
      header: "Contact Phone Number", 
      sortable: true, 
      filter: true 
    },
    { 
      field: "requestProgressStatus", 
      header: "Status", 
      sortable: true, 
      filter: true,
      body: (rowData) => rowData?.requestProgressStatus || 'Active'
    },
    { 
      field: "request.study_name", 
      header: "Request Name", 
      sortable: true, 
      filter: true,
      body: (rowData) => rowData?.request?.study_name || '-'
    },
    { 
      field: "updatedAt", 
      header: "Last Updated", 
      sortable: true, 
      filter: true, 
      body: (rowData) => {
        return rowData.updatedAt ? new Date(rowData.updatedAt).toLocaleString('en-GB') : '-';
      }
    }
  ];

  const actions = [
    { 
      text: "View Details", 
      color: 'primary', 
      onClick: (row) => navigate(`/${persona}/manufacturers-site/details/${row.id}`) 
    }
  ];

  return (
    <div>
      <DataTableComponent
        data={data}
        columns={columns}
        loading={loading}
        paginationParams={paginationParams}
        totalRecords={data?.length}
        onDataTableEvent={onDataTableEvent}
        enableCreate={false}
        enablePagination={true}
        enableLazyLoading={false}
        enableExport={true}
        actions={actions}
        sectionName={`Manufacturer-Sites-${new Date().getDate()}-${new Date().getMonth() + 1}-${new Date().getFullYear()}-${new Date().getHours()}-${new Date().getMinutes()}`}
      />
    </div>
  );
};

export default ManufacturerSiteList;

